module.exports = __webpack_public_path__ + "img/img_banner.0627c9b5.png";